exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_container__1ZVzG{display:flex;flex-direction:row;align-items:flex-start}.style_select__1cFb6{display:flex;justify-content:center;align-items:center}.style_inlineSearch__3IJgD{display:flex;flex-direction:row;align-items:baseline}.style_claimContent__gSpai{display:block}", ""]);

// exports
exports.locals = {
	"container": "style_container__1ZVzG",
	"select": "style_select__1cFb6",
	"inlineSearch": "style_inlineSearch__3IJgD",
	"claimContent": "style_claimContent__gSpai"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/AddIdentityDialog/style.less
// module id = 1805
// module chunks = 8